import type { ScenariaPlan } from "src/model/model";

export interface GenerationEstimate {
  sceneCount: number;
  imageCount: number;
}

export const computeGenerationEstimate = (
  plan: ScenariaPlan | undefined,
  blockadeEnabled: boolean,
): GenerationEstimate => {
  const scenes = plan?.sceneOutline ?? [];
  const sceneCount = scenes.length;
  const imageCount = blockadeEnabled
    ? scenes.filter((scene) => scene.mediaType === "image360").length
    : 0;
  return { sceneCount, imageCount };
};
